import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
var CalendarHeader = function CalendarHeader(_ref) {
  var range = _ref.range,
    selectedMonth = _ref.selectedMonth,
    nextMonth = _ref.nextMonth,
    onChangeMonth = _ref.onChangeMonth;
  // TODO :: compress
  return /*#__PURE__*/React.createElement("div", {
    className: "calendar-header ".concat(range && 'calendar-header__range')
  }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
    className: "calendar-header__angle",
    onClick: function onClick() {
      return onChangeMonth(moment(selectedMonth).subtract(1, 'months').format('YYYY-MM'));
    }
  }, /*#__PURE__*/React.createElement(FaAngleLeft, null)), /*#__PURE__*/React.createElement("div", {
    className: "calendar-header__title"
  }, moment(selectedMonth).format('MMM, YYYY')), /*#__PURE__*/React.createElement("div", {
    className: "calendar-header__angle",
    onClick: function onClick() {
      if (range) return;
      onChangeMonth(moment(selectedMonth).add(1, 'months').format('YYYY-MM'));
    }
  }, !range && /*#__PURE__*/React.createElement(FaAngleRight, null))), range && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
    className: "calendar-header__angle",
    onClick: function onClick() {
      if (range) return;
      onChangeMonth(moment(selectedMonth).subtract(1, 'months').format('YYYY-MM'));
    }
  }, !range && /*#__PURE__*/React.createElement(FaAngleLeft, null)), /*#__PURE__*/React.createElement("div", {
    className: "calendar-header__title"
  }, moment(nextMonth).format('MMM, YYYY')), /*#__PURE__*/React.createElement("div", {
    className: "calendar-header__angle",
    onClick: function onClick() {
      return onChangeMonth(moment(selectedMonth).add(1, 'months').format('YYYY-MM'));
    }
  }, /*#__PURE__*/React.createElement(FaAngleRight, null)))));
};
export default CalendarHeader;